import { apiClient } from './client';

export function getReturnPolicies (shopId: number | string) {
  return apiClient.get(`/${shopId}/return-policies`);
}

export function getReturnPolicyUpdates (shopId: number | string, policyId: number | string) {
  return apiClient.get(`/${shopId}/return-policies/${policyId}/updates`);
}
